import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ignoreFromVerification } from "../api.ts";
import { donationsVerificationKeys } from "../queries/keys.ts";
import { IgnoreFromVerificationRequest } from "@/features/operations/verifications/donations/types.ts";

// Mutation hook for ignoring items from verification
export const useIgnoreVerificationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: IgnoreFromVerificationRequest) => {
      const response = await ignoreFromVerification(data);
      return response.data;
    },
    onSuccess: async () => {
      // Invalidate unassigned stages query to refetch
      await queryClient.invalidateQueries({
        queryKey: [...donationsVerificationKeys.all],
      });
    },
  });
};
